import { zSchema } from "@zeal/common";

export const getSshKeyRotationsRequestSchema = zSchema.object({
  state_code: zSchema.string().optional(),
});

export type TGetSshKeyRotationsRequestSchema = zSchema.infer<
  typeof getSshKeyRotationsRequestSchema
>;

const sshKeyRotationItemSchema = zSchema.object({
  id: zSchema.string(),
  state_code: zSchema.string(),
  key_version: zSchema.number(),
  public_key: zSchema.string(),
  status: zSchema.string(),
  rotation_period_days: zSchema.number(),
  created_at: zSchema.union([zSchema.string(), zSchema.date()]),
  activated_at: zSchema.union([zSchema.string(), zSchema.date()]).optional(),
  expired_at: zSchema.union([zSchema.string(), zSchema.date()]).optional(),
  rotation_due_at: zSchema.union([zSchema.string(), zSchema.date()]).optional(),
  is_nearing_expiry: zSchema.boolean().optional(),
  days_until_rotation_due: zSchema.number().optional(),
});

export type TSshKeyRotationItemSchema = zSchema.infer<
  typeof sshKeyRotationItemSchema
>;

export const getSshKeyRotationsResponseSchema = zSchema.object({
  items: zSchema.array(sshKeyRotationItemSchema),
});

export type TGetSshKeyRotationsResponseSchema = zSchema.infer<
  typeof getSshKeyRotationsResponseSchema
>;
